module.exports = __webpack_public_path__ + "img/arbonia.9d523eb6.svg";